"use strict";

var _taggedTemplateLiteral = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _objectSpread = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _objectWithoutProperties = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _chunkTPZR5EWLjs = require('./chunk-TPZR5EWL.js');

var _chunkYS2SRWUBjs = require('./chunk-YS2SRWUB.js');

var _chunkNESC3UD7js = require('./chunk-NESC3UD7.js');

var _styledcomponents = require('styled-components');

var _styledcomponents2 = _interopRequireDefault(_styledcomponents);

var _jsxruntime = require('react/jsx-runtime');

var N = function N(_ref) {
  var e = _ref.$onlyInput,
      r = _ref.children,
      o = _ref.disabled,
      a = _ref.errorText,
      s = _ref.errorTextId,
      _ref$hasError = _ref.hasError,
      l = _ref$hasError === void 0 ? !1 : _ref$hasError,
      n = _ref.helpText,
      t = _ref.labelText,
      _ref$secure = _ref.secure,
      d = _ref$secure === void 0 ? !1 : _ref$secure,
      _ref$showTopLeft = _ref.showTopLeft,
      m = _ref$showTopLeft === void 0 ? !!t : _ref$showTopLeft,
      _ref$showTopRight = _ref.showTopRight,
      g = _ref$showTopRight === void 0 ? d : _ref$showTopRight,
      _ref$topLeft = _ref.topLeft,
      $ = _ref$topLeft === void 0 ? _jsxruntime.jsx.call(void 0, W, {
    $disabled: o,
    forwardedAs: "span",
    children: t
  }) : _ref$topLeft,
      _ref$topRight = _ref.topRight,
      c = _ref$topRight === void 0 ? _jsxruntime.jsxs.call(void 0, E, {
    $disabled: o,
    forwardedAs: "span",
    children: [_jsxruntime.jsx.call(void 0, _chunkYS2SRWUBjs.a, {}), "Secure"]
  }) : _ref$topRight,
      x = _objectWithoutProperties(_ref, ["$onlyInput", "children", "disabled", "errorText", "errorTextId", "hasError", "helpText", "labelText", "secure", "showTopLeft", "showTopRight", "topLeft", "topRight"]);

  return e ? r : _jsxruntime.jsxs.call(void 0, y, _objectSpread({}, x, {
    children: [m && $, g && c, _jsxruntime.jsx.call(void 0, M, {
      children: r
    }), !!a && l && _jsxruntime.jsx.call(void 0, _chunkTPZR5EWLjs.k, {
      $gridLocation: "caption",
      color: "error",
      id: s,
      children: a
    }), !!n && !a && _jsxruntime.jsx.call(void 0, A, {
      $disabled: o,
      children: n
    })]
  }));
},
    y = _styledcomponents2.default.label(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", ";\n    display: grid;\n    grid-template-columns: 1fr min-content;\n    grid-template-areas:\n        ", "\n        'input input'\n        ", ";\n    grid-template-rows:\n        ", "\n        1fr\n        ", ";\n\n    grid-row-gap: ", ";\n"])), _chunkNESC3UD7js.e, function (_ref2) {
  var e = _ref2.$hasContentAbove;
  return e && "'topleft topright'";
}, function (_ref3) {
  var e = _ref3.$hasContentBelow;
  return e && "'caption caption'";
}, function (_ref4) {
  var e = _ref4.$hasContentAbove;
  return e && "min-content";
}, function (_ref5) {
  var e = _ref5.$hasContentBelow;
  return e && "min-content";
}, function (_ref6) {
  var e = _ref6.theme;
  return e.spacing.xxs;
}),
    M = _styledcomponents2.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    grid-area: input;\n"]))),
    W = exports.a = _styledcomponents2.default.call(void 0, _chunkTPZR5EWLjs.j)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    grid-area: topleft;\n    white-space: nowrap;\n\n    ", "\n"])), function (_ref7) {
  var e = _ref7.$disabled,
      r = _ref7.theme;
  return e && _styledcomponents.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n            color: ", ";\n        "])), r.color.text.disabled);
}),
    A = exports.b = _styledcomponents2.default.call(void 0, _chunkTPZR5EWLjs.k)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    grid-area: caption;\n    white-space: nowrap;\n\n    ", "\n"])), function (_ref8) {
  var e = _ref8.$disabled,
      r = _ref8.theme;
  return e && _styledcomponents.css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n            color: ", ";\n        "])), r.color.text.disabled);
}),
    E = _styledcomponents2.default.call(void 0, _chunkTPZR5EWLjs.j)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    grid-area: topright;\n    display: flex;\n    align-items: center;\n    gap: 2px;\n\n    ", "\n"])), function (_ref9) {
  var e = _ref9.$disabled,
      r = _ref9.theme;
  return e && _styledcomponents.css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n            color: ", ";\n        "])), r.color.text.disabled);
}),
    q = exports.c = function (e, r) {
  var o = e,
      a = !!(o.errorText && o.hasError) || !!o.helpText,
      s = !!o.labelText || !!o.secure,
      l = !a && !s && !r,
      n = {
    $gridLocation: o.$gridLocation,
    $hasContentAbove: s,
    $hasContentBelow: a,
    $margin: o.$margin,
    $marginBottom: o.$marginBottom,
    $marginLeft: o.$marginLeft,
    $marginRight: o.$marginRight,
    $marginTop: o.$marginTop,
    $onlyInput: l,
    $padding: o.$padding,
    $paddingBottom: o.$paddingBottom,
    $paddingLeft: o.$paddingLeft,
    $paddingRight: o.$paddingRight,
    $paddingTop: o.$paddingTop,
    children: null,
    className: o.className,
    disabled: o.disabled,
    errorText: o.errorText,
    errorTextId: o.errorTextId,
    hasError: o.hasError,
    helpText: o.helpText,
    labelText: o.labelText,
    secure: o.secure
  },
      t = {};

  if (n.$onlyInput) {
    var _o = o,
        d = _o.$gridLocation,
        m = _o.$margin,
        g = _o.$marginBottom,
        $ = _o.$marginLeft,
        c = _o.$marginRight,
        x = _o.$marginTop,
        u = _o.$padding,
        L = _o.$paddingBottom,
        B = _o.$paddingLeft,
        F = _o.$paddingRight,
        I = _o.$paddingTop,
        R = _o.className,
        w = _objectWithoutProperties(_o, ["$gridLocation", "$margin", "$marginBottom", "$marginLeft", "$marginRight", "$marginTop", "$padding", "$paddingBottom", "$paddingLeft", "$paddingRight", "$paddingTop", "className"]);

    o = w, t = {
      $gridLocation: d,
      $margin: m,
      $marginBottom: g,
      $marginLeft: $,
      $marginRight: c,
      $marginTop: x,
      $padding: u,
      $paddingBottom: L,
      $paddingLeft: B,
      $paddingRight: F,
      $paddingTop: I,
      className: R
    };
  }

  return n.hasError && (t["aria-invalid"] = !0), n.errorText && n.hasError && n.errorTextId && (t["aria-errormessage"] = n.errorTextId), {
    containerProps: t,
    FormComponentWrapper: N,
    formComponentWrapperProps: n,
    rest: o
  };
};

exports.a = W;
exports.b = A;
exports.c = q;